export default __webpack_public_path__ + "static/progress3-0f248a5abb90944005d80c5dc6bd64d6.mp4";